import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared';
import { AuthenticationComponent } from './containers/authentication/authentication.component';
import { HomeComponent } from './containers/home/home.component';
import { StatusComponent } from './containers/status/status.component';
import { ErrorComponent } from './containers/error/error.component';
import { OptInComponent } from './containers/opt-in/optIn.component';
import { CustomScreenComponent } from './containers/custom-screen/custom-screen.component';
import { PolicyComponent } from './containers/policy/policy.component';

export const appRoutes: Routes = [
  { path: 'authentication', component: AuthenticationComponent, pathMatch: 'full' },
  { path: '', redirectTo: 'authentication', canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'status', component: StatusComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'optIn', component: OptInComponent, canActivate: [AuthGuard], pathMatch: 'full' },
  { path: 'error', component: ErrorComponent, pathMatch: 'full' },
  { path: 'close', component: ErrorComponent, pathMatch: 'full' },
  { path: 'custom', component: CustomScreenComponent, pathMatch: 'full'},
  { path: 'policy', component: PolicyComponent, pathMatch: 'full'}
];




// WEBPACK FOOTER //
// ./src/app/app.routing.ts